export enum KoType {
    INFO = 'INFO',
    PARTIAL = 'PARTIAL',
    TOTAL = 'TOTAL',
}
